// LoadingScreen.js
import React, { useEffect, useState } from 'react';
import ".././component/LoadingScreen.css"

const LoadingScreen = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 15000); // 15 seconds

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="loading-screen">
      <div className="spinner"></div>
      <div className="loading-text">Please wait, loading...</div>
    </div>
  );
};

export default LoadingScreen;
